function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m176.982 264.598 158.213-158.213-77.393-77.394c-5.85-5.851-15.331-5.859-21.191-.022l-236.611 235.629z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m488.195 256.598h-35c-24.813 0-45 20.187-45 45v51h-36.469c-9.139-27.057-40.064-39.715-65.41-27.091l-25.909-25.909 52.184-52.184c17.544-17.544 17.544-46.089 0-63.633l-16.184-16.184-122.605 122.607c-2.813 2.813-6.628 4.394-10.606 4.394h-85.987l84.963 84.962c5.977 4.518 14.336 3.939 19.63-1.356l57.394-57.394 25.909 25.909c-15.475 31.069 7.238 67.878 42.091 67.878 20.671 0 38.255-13.42 44.531-32h36.469v51c0 24.813 20.187 45 45 45h35c8.284 0 15-6.716 15-15v-192c-.001-8.283-6.717-14.999-15.001-14.999z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m68.882 308.697-16.294 16.294c-5.858 5.857-5.858 15.355 0 21.213l56 56c5.858 5.858 15.355 5.858 21.213 0l16.294-16.294z"
}));

function Svg310(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 503.195 503.195",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg310);
export default __webpack_public_path__ + "static/media/3_10.2bc43702.svg";
export { ForwardRef as ReactComponent };